import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders, getHttpHeadersExcel } from "../ApiUtils";

const quizApiUrl = `${baseApiUrl}/api/Quiz`;

export async function getQuizList(search) {
    return await httpRequest(fetchQuizList.bind(this, search));
}

async function fetchQuizList(search) {
    let config = getHttpHeaders();

    const searchParameters = new URLSearchParams();
    addParameter(searchParameters, search.currentPage, "PageNumber");
    addParameter(searchParameters, search.quizReference, "QuizReference");
    addParameter(searchParameters, search.quizType, "QuizType");
    addParameter(searchParameters, search.followUpEventId, "FollowUpEventId");
    addParameter(searchParameters, search.contractTypeId, "ContractTypeId");
    addParameter(searchParameters, search.language, "Language");
    addParameter(searchParameters, search.quizStatus, "QuizStatus");
    addParameter(searchParameters, search.orderBy, "OrderBy");
    addParameter(searchParameters, search.quizId, "QuizId");

    return await axios.get(quizApiUrl + "?" + searchParameters.toString(), config);
}

async function addParameter(searchParameters, value, queryName) {
    if (value) {
        searchParameters.append(queryName, value)
    }
}

export async function getQuizById(id) {
    return await httpRequest(fetchQuizById.bind(this, id));
}

async function fetchQuizById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${quizApiUrl}/${id}`, config);
}

export async function getQuizEditableList() {
    return await httpRequest(fetchQuizEditableList.bind(this));
}

async function fetchQuizEditableList() {
    let config = getHttpHeaders();
    return await axios.get(`${quizApiUrl}/Editable`, config);
}

export async function addQuiz(newQuiz) {
    return await httpRequest(postQuiz.bind(this, newQuiz));
}

async function postQuiz(newQuiz) {
    let config = getHttpHeaders();
    return await axios.post(`${quizApiUrl}`, newQuiz, config);
}

export async function updateQuiz(updatedQuiz) {
    return await httpRequest(putQuiz.bind(this, updatedQuiz));
}

async function putQuiz(updatedQuiz) {
    let config = getHttpHeaders();
    return await axios.put(`${quizApiUrl}`, updatedQuiz, config);
}

export async function deleteQuiz(id) {
    return await httpRequest(fetchDeleteQuiz.bind(this, id));
}

async function fetchDeleteQuiz(id) {
    let config = getHttpHeaders();
    return await axios.delete(`${quizApiUrl}/${id}`, config);
}

export async function cloneQuiz(quizId) {
    return await httpRequest(fetchCloneQuiz.bind(this, quizId));
}

async function fetchCloneQuiz(quizId) {
    let config = getHttpHeaders();
    return await axios.post(`${quizApiUrl}/clone`, quizId, config);
}

export async function publishQuiz(quizId) {
    return await httpRequest(fetchPublishQuiz.bind(this, quizId));
}

async function fetchPublishQuiz(quizId) {
    let config = getHttpHeaders();
    return await axios.post(`${quizApiUrl}/publish`, quizId, config);
}

export async function getConsultantEvaluationReport(isFirstSemester) {
    return await httpRequest(fetchConsultantEvaluationExcel.bind(this, isFirstSemester));
}
async function fetchConsultantEvaluationExcel(isFirstSemester) {
    let config = getHttpHeadersExcel();
    return await axios.get(`${quizApiUrl}/ConsultantEvaluation?isFirstSemester=${isFirstSemester}`, config);
}